<template>
  <div class="widget-snippet w-100 d-f fd-c m-b">
    <!-- Section header (same visual as Dropbox toggle row, without switch) -->
    <!-- <div class="flex-1 d-f fd-c min-w-0">
      <p class="m-0">External Script Snippet</p>
    </div> -->
    <div class="widget-snippet-body d-f fd-c g">
      <p class="mute">Copy paste this code in the body tag of your website:</p>
      <div class="p-rel w-100">
        <div class="input-container w-100 desc-field desc-textarea-wrap">
          <label class="label" for="settings-widget-snippet-code">Embed code</label>
          <textarea
            id="settings-widget-snippet-code"
            class="desc-textarea"
            maxlength="200"
            rows="3"
            readonly
            :value="widgetCode"
          />
        </div>
        <a
          class="underline text-link tt-up p-a t-o r-0 m"
          href="#"
          @click.prevent="$emit('copy')"
          >Copy code</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingsLabelWidgetSnippet",
  props: {
    widgetCode: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";
@import "@/scss/_mixins.scss";

.toggle-wrapper {
  min-height: $btn-height;
  height: auto;
}

.desc-field {
  position: relative;

  .char-count {
    position: absolute;
    right: $mg-desktop-md;
    bottom: calc(#{$mg-desktop-md} / 2);
    pointer-events: none;
  }
}

.desc-textarea-wrap .desc-textarea {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 140px;
  resize: vertical;
  min-height: 60px;
  padding-right: 2.5rem;
  padding-bottom: 1.5rem;
  -webkit-overflow-scrolling: touch;
  word-wrap: break-word;
}
</style>
